var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.12221 14.4728C8.12149 15.3598 10.5027 15.3116 12.5419 14.1343C15.9298 12.1783 17.0906 7.84618 15.1345 4.45828L14.9262 4.09743M2.86546 11.5417C0.909454 8.1538 2.07024 3.8217 5.45814 1.8657C7.4973 0.68839 9.87851 0.640217 11.8778 1.52719M1.07788 11.6114L3.35459 12.2215L3.96463 9.94475M14.0356 6.05479L14.6456 3.77808L16.9223 4.38813",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.27fad7eecaf6c0d90695def35469b0cc.svg";
export { ForwardRef as ReactComponent };